import { render, staticRenderFns } from "./StatusTag.vue?vue&type=template&id=a5780ac4"
import script from "./StatusTag.js?vue&type=script&lang=js&external"
export * from "./StatusTag.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports